/**
 * Helpers pour les réponses d'erreur de validation HTTP (ex. 422) renvoyées par l'API.
 */

export function isRtkQueryHttpError(
  error: unknown
): error is { status: number; data?: unknown } {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    typeof (error as { status: unknown }).status === 'number'
  )
}

/**
 * Préfère le message de la première violation, sinon `detail` (corps JSON typique Problem Details + violations).
 */
export function messageFromApiValidationBody(data: unknown): string | null {
  if (typeof data !== 'object' || data === null) {
    return null
  }
  const body = data as {
    detail?: string
    violations?: Array<{ message?: string }>
  }
  const fromViolation = body.violations?.find(
    (v) => typeof v.message === 'string' && v.message.length > 0
  )
  if (fromViolation?.message) {
    return fromViolation.message
  }
  if (typeof body.detail === 'string' && body.detail.length > 0) {
    return body.detail
  }
  return null
}
